<script lang="ts">
	import { onMount } from "svelte";

	/**
	 * The text content to display.
	 * @type {string}
	 * @default ""
	 */
	export let text: string = "";

	/**
	 * The CSS class for clamping the text (e.g., `line-clamp-3`).
	 * @type {string}
	 * @default ""
	 */
	export let clamp: string = "";

	/**
	 * Whether the text is overflowing its container.
	 * @type {boolean}
	 * @default false
	 */
	export let overflowing = false;

	/**
	 * The color of the "read more" link text.
	 * @type {string}
	 * @default "text-blue-500"
	 */
	export let readMoreColor = "text-blue-500";

	/**
	 * Whether the "read more" functionality is active.
	 * @type {boolean}
	 * @default false
	 */
	export let readmore = false;

	/**
	 * On component mount, check if the text overflows its container.
	 */
	onMount(async () => {
		overflowing = multiLineOverflows();
	});

	/**
	 * Determines if the text overflows its container.
	 * @returns {boolean} Whether the text overflows.
	 */
	function multiLineOverflows() {
		const el = ref;
		return el.scrollHeight > el.clientHeight;
	}

	/**
	 * Reference to the text container element.
	 * @type {HTMLElement}
	 */
	let ref: HTMLElement;
</script>

<p class={$$props.class}>
	<span bind:this={ref} class={`${!readmore && clamp}`}>
		{text}
		<slot />
	</span>
	{#if overflowing}
		<button
			on:click|stopPropagation|preventDefault={(event) => {
				event.stopImmediatePropagation();

				readmore = !readmore;
			}}
			class="font-medium {readMoreColor} hover:underline"
		>
			{readmore ? "Lees minder" : "Lees meer"}
		</button>
	{/if}
</p>
